import {Component, Input, OnInit} from '@angular/core';
import {circles} from '../data.types'

@Component({
  selector: 'as-data-circles',
  templateUrl: './data-circles.component.html',
  styleUrls: ['./data-circles.component.scss']
})
export class DataCirclesComponent implements OnInit {

  @Input() data: Array<circles>;
  @Input() header: string;
  constructor() { }

  ngOnInit() {

  }

}
